import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/row/Row.less');
const cx = classnames.bind(styles);

export interface IRowProps
{
    children:JSX.Element | JSX.Element[];
    center?:boolean;
    verticalCenter?:boolean;
}

export class Row extends React.Component<IRowProps>
{
    public render():JSX.Element
    {
        const {children, center = false, verticalCenter = false, ...restProps} = this.props;

        return (
            <div className={cx(styles.base, {center}, {verticalCenter})} {...restProps}>
                {children}
            </div>
        );
    }
}

